import type { SVGProps } from 'react';

const SvgCopy02Sm = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#Copy_02Sm_svg__a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.666 5.333V3.467c0-.747 0-1.12-.145-1.406a1.33 1.33 0 0 0-.583-.582c-.285-.146-.658-.146-1.405-.146H3.466c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582-.145.285-.145.659-.145 1.406v5.066c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146h1.867m2.133 4h5.067c.747 0 1.12 0 1.405-.146.251-.128.455-.332.583-.582.145-.286.145-.659.145-1.406V7.467c0-.747 0-1.12-.145-1.406a1.33 1.33 0 0 0-.583-.582c-.285-.146-.658-.146-1.405-.146H7.466c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582-.145.285-.145.659-.145 1.406v5.066c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146"
      />
    </g>
    <defs>
      <clipPath id="Copy_02Sm_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCopy02Sm;
